import FetchClient from "./FetchClient";
import UmbracoClient from "./UmbracoClient";

export function createUmbracoClient()
{
    return new UmbracoClient(new FetchClient());
}

export default {
    umbracoClient: createUmbracoClient()
};